@if (disabled === false) {
  <button
    class="icon-button"
    [ngClass]="{ 'is-favorite': isFavorite }"
    (click)="addToFavorites.next($event)"
    pcp-ui-icon-button
    size="medium"
    mat-icon-button
    [style.transform]="'scale(' + scale + ')'"
    >
    <mat-icon
      [fontSet]="fontSet"
      [fontIcon]="isFavorite ? fontIconChecked : fontIconUnchecked"
      [class.outlined]="!isFavorite"
      (click)="addToFavorites.next($event)"
      class="favorite"
      [title]="'button.favorite.add' | transloco"
    ></mat-icon>
  </button>
}
